import { isThursday } from "date-fns";
import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { User, UserFormValues } from "../models/user";
import { router } from "../router/Routes";
import { store } from "./store";

export default class UserStore {
    user: User | null = null;
    facebookLoading = false;
    refreshTokenTimeout: any;

    constructor() {
        makeAutoObservable(this);
    }

    get isLoggedIn() {
        return !!this.user; //' to cast object to boolient
    }
   
    login = async (userFormValues: UserFormValues) => {
        try{
            const userResponce = await agent.Account.login(userFormValues);
            console.log(userResponce);

            store.commonStore.setToken(userResponce.token);
            this.startRefreshTokenTimer(userResponce); //'n

            runInAction(() => { //' -> becouse we used await and we awaited
                this.user = userResponce;
            });

            router.navigate('/activities');

            store.modalStore.closeModal(); //' n
        } catch(error) {
            console.log(error);
            throw error; //' n for Yup
        }
    }

    logout = () => {
        store.commonStore.setToken(null);

        //localStorage.removeItem('jwtToken'); //' nn sice we have reaction to  this.token = token; changes in CommonStore
        
        this.user = null;
        router.navigate('/'); //' -> Homepage
    }

    register_o = async (userFormValues: UserFormValues) => {
        try{
            const userResponce = await agent.Account.register(userFormValues);
            console.log(userResponce);
            store.commonStore.setToken(userResponce.token); //' n
            this.startRefreshTokenTimer(userResponce); //'n

            runInAction(() => { //' -> becouse we used await and we awaited
                this.user = userResponce;
            });

            router.navigate('./activities'); //'n
            store.modalStore.closeModal(); //' n
        } catch(error) {
            console.log(error);
            throw error; //' n for Yup
        }
    }

    register = async (userFormValues: UserFormValues) => {
        try{
            //const userResponce = 
            await agent.Account.register(userFormValues);
            // console.log(userResponce);
            // store.commonStore.setToken(userResponce.token); //' n
            // this.startRefreshTokenTimer(userResponce); //'n
            // runInAction(() => { //' -> becouse we used await and we awaited
            //     this.user = userResponce;
            // });

            //router.navigate('./activities'); //'n
            router.navigate(`/account/registerSuccess?email=${userFormValues.email}`); //'n
            store.modalStore.closeModal(); //' n
        //} catch(error) { //'x
        } catch(error: any) { //'n
            console.log(error);
            //throw error; //'n for Yup ==> x

            if (error?.response?.status === 400) { //'n k
                throw error; //'n for Yup ==> x
            }
            store.modalStore.closeModal();
            console.log(500);
        }
    }

    ConfirmEmail = async (tokenEncoded: string, email: string) => {
        try{
            //const userResponce = 
            await agent.Account.verifyEmail(tokenEncoded, email);
            // console.log(userResponce);
            // store.commonStore.setToken(userResponce.token); //' n
            // this.startRefreshTokenTimer(userResponce); //'n
            // runInAction(() => { //' -> becouse we used await and we awaited
            //     this.user = userResponce;
            // });

            //router.navigate('./activities'); //'n
            //router.navigate(`/account/registerSuccess?email=${userFormValues.email}`); //'n
            //store.modalStore.closeModal(); //' n

            router.navigate('/activities');
        } catch(error) {
            console.log(error);
            throw error; //' n for Yup
        }
    }

    getUser = async () => {
        try {
            const userResponce = await agent.Account.current();
            console.log(userResponce);

            store.commonStore.setToken(userResponce.token); //'n

            runInAction(() => { //' -> becouse we used await and we awaited
                this.user = userResponce;
            });

            this.startRefreshTokenTimer(userResponce); //'n
        } catch (error) {
            console.log(error);
        }
    }

    setImage = (imageUrl: string) => {
        try {
            if (this.user) {
                //this.user?.photoUrl = imageUrl; // remove ?
                this.user.image = imageUrl;
            }
        } catch (error) {
            console.log(error);
        }
    }

    setDisplayName = (disolayName: string) => {
        if(this.user) { this.user.displayName = disolayName; }
    }

    facebookLogin = async (accessToken: string) => {
        try {
            this.facebookLoading = true;
            const userResponce = await agent.Account.facebookLogin(accessToken);
            console.log(userResponce);
            store.commonStore.setToken(userResponce.token);
            this.startRefreshTokenTimer(userResponce); //'n

            runInAction(() => {
                this.user = userResponce;
                this.facebookLoading = false;
            })

            router.navigate('/activities');
        } catch (error) {
            console.log(error);

            runInAction(() => {
                this.facebookLoading = false;
            })
        }
    }

    refreshToken = async () => { //'n
        this.stopRefreshTokenTimer();

        try {
            const userResponce = await agent.Account.refreshToken();
           
            runInAction(() => {
                this.user = userResponce;
            })

            store.commonStore.setToken(userResponce.token);
            this.startRefreshTokenTimer(userResponce);
        } catch (error) {
            console.log(error);
        }
    }

    private startRefreshTokenTimer(user: User) { //'n
        const payloadToken = user.token.split('.')[1];
        const decodedPayloadToken = atob(payloadToken); // atob() to decode token
        const jwtToken = JSON.parse(decodedPayloadToken);

        const expiryDate = new Date(jwtToken.exp * 1000);
        //const timeout = expiryDate.getTime() - Date.now() - (30 * 1000); // 30 seconds is short
        const timeout = expiryDate.getTime() - Date.now() - (60 * 1000); // 30 seconds is short

        this.refreshTokenTimeout = setTimeout(this.refreshToken, timeout);
    }

    private stopRefreshTokenTimer() { //'n
        clearTimeout(this.refreshTokenTimeout);
    }

}